import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Share2 = createReactComponent("Share2", ["svg", defaultAttributes, [["circle", {
  cx: "18",
  cy: "5",
  r: "3",
  key: "80x6fa"
}], ["circle", {
  cx: "6",
  cy: "12",
  r: "3",
  key: "qdtmtr"
}], ["circle", {
  cx: "18",
  cy: "19",
  r: "3",
  key: "17sjzy"
}], ["line", {
  x1: "8.59",
  y1: "13.51",
  x2: "15.42",
  y2: "17.49",
  key: "3elu7f"
}], ["line", {
  x1: "15.41",
  y1: "6.51",
  x2: "8.59",
  y2: "10.49",
  key: "e3sph7"
}]]]);
export default Share2;